import { connect } from 'react-redux';
import GameForm from '../components/forms/GameForm';
import {withRouter} from 'react-router-dom';
import { createGameAction} from '../store/actions';

const data = {
    name : '',
    description : ''
}

function dataWithUserId(state) {
    const auth = state.firebaseReducer.auth;
    data.ownerId = auth.uid;
    return data;
}

const mapDispatchToProps = ({
    onSubmit: createGameAction
});

const mapStateToProps = (state, ownProps) => {
    return {
        initialValues: dataWithUserId(state)
    }
};

const GameCreateContainer = withRouter(connect(mapStateToProps, mapDispatchToProps)(GameForm));


export default GameCreateContainer;